import { render, staticRenderFns } from "./operateTack.vue?vue&type=template&id=2c9184b7&scoped=true"
import script from "./operateTack.vue?vue&type=script&lang=js"
export * from "./operateTack.vue?vue&type=script&lang=js"
import style0 from "./operateTack.vue?vue&type=style&index=0&id=2c9184b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9184b7",
  null
  
)

export default component.exports